import { isFlagler } from '../../constants/brandConfig';

const styles = isFlagler ? require('./flagler.styl') : require('./index.styl');

export default styles;



// WEBPACK FOOTER //
// ./src/components/Auth/index.styles.js